"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAddNodeButton = exports.StyledFormControlLabel = exports.StyledTree = exports.StyledButtonWrapper = exports.StyledHeaderContainer = exports.StyledFilterButton = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const x_tree_view_1 = require("@mui/x-tree-view");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledFilterButton = (0, styled_components_1.default)(ui_components_1.Button) `
  white-space: nowrap;
  padding: 0;
  margin: 0;
  min-width: 2rem;

  &:hover,
  &:focus,
  &:active,
  &:focus-visible {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .MuiButton-startIcon svg path,
  .MuiButton-endIcon svg path {
    fill: none;
  }

  &:active {
    .MuiButton-startIcon svg path,
    .MuiButton-endIcon svg path {
      fill: ${ui_components_1.baseColors.teal300};
    }
  }

  &.menu--open {
    background-color: transparent !important;
    
    .MuiButton-startIcon svg path,
    .MuiButton-endIcon svg path {
      fill: ${ui_components_1.baseColors.teal300};
    }
  }
`;
exports.StyledHeaderContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.StyledButtonWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.StyledTree = (0, styled_components_1.default)(x_tree_view_1.SimpleTreeView) `
  flex: 1;
  overflow: auto;
  border-radius: 4px;
  max-height: 100%;
  position: relative;
  // space for the update mark
  padding-left: ${({ theme }) => theme.spacing(2)};

  .MuiTreeItem-content {
    width: unset;
  }

  .MuiTreeItem-label {
    padding: ${({ theme }) => theme.spacing(0.625)};
    font-size: 0.875rem;
  }

  li.root-parent > div {
    .node-title {
      font-size: 0.75rem;
      line-height: 1.66;
      color: ${({ theme }) => theme.palette.accent.main};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .root-node-title {
      font-size: 0.875rem;
      text-transform: uppercase;
      color: ${ui_components_1.baseColors.primaryGreen300};
    }
  }
`;
exports.StyledFormControlLabel = (0, styled_components_1.default)(material_1.FormControlLabel) `
  margin-left: 0;
  margin-right: 0;
`;
exports.StyledAddNodeButton = (0, styled_components_1.default)(ui_components_1.Button) `
  min-width: 2rem;

  &&:hover,
  &&:focus,
  &&:active,
  &&:focus-visible {
    background-color: transparent;
    box-shadow: none;
  }
`;
